import { useState } from "react";
import { Trash2 } from "lucide-react";
import { toast } from "../../lib/notify";
import { http, formatApiError } from "../../lib/api";
import { ConfirmDelete } from "../ConfirmDelete";

// Taşeronu (cariyi) sil — bekleyen iş emri varsa backend engeller; bağlı kullanıcı hesapları isteğe bağlı silinir
export default function SubDeleteButton({ cari, onDeleted }) {
  const [confirm, setConfirm] = useState(false);
  const [withUsers, setWithUsers] = useState(true);
  const n = cari.users.length;
  const remove = async () => {
    try {
      const { data } = await http.delete(`/subcontractors/${cari.id}`, { params: { delete_users: withUsers ? 1 : 0 } });
      toast.success(`${cari.name} silindi${data.deleted_users ? ` · ${data.deleted_users} kullanıcı hesabı kaldırıldı` : data.remaining_users ? ` · ${data.remaining_users} kullanıcı "Tüm Kullanıcılar"da cari atanmamış olarak kaldı` : ""}`);
      setConfirm(false); onDeleted?.();
    } catch (e) { toast.error(formatApiError(e)); }
  };
  return (
    <>
      <button type="button" onClick={() => setConfirm(true)} data-testid="sub-delete" title="Taşeronu (cari kartını) sil"
        className="inline-flex items-center gap-1 px-2.5 py-1.5 rounded-md border border-red-300 text-xs font-semibold bg-white text-red-700 hover:bg-red-50"><Trash2 className="w-3.5 h-3.5" /> Taşeronu Sil</button>
      {confirm && (
        <ConfirmDelete title="Taşeronu sil" testid="sub-delete-confirm" onConfirm={remove} onCancel={() => setConfirm(false)}
          message={(
            <div className="space-y-2">
              <div><b>{cari.name}</b> taşeron listesinden ve cari kartlarından kaldırılacak. Geçmiş iş emirleri ve hakediş kayıtları silinmez; {cari.work.pending > 0 ? <b className="text-red-700">{cari.work.pending} bekleyen iş emri olduğu için silme engellenecek.</b> : "bekleyen iş emri yok."}</div>
              {n > 0 && <label className="inline-flex items-center gap-2 text-xs"><input type="checkbox" checked={withUsers} onChange={(e) => setWithUsers(e.target.checked)} data-testid="sub-delete-with-users" /> Bağlı {n} taşeron kullanıcı hesabını da sil {!withUsers && <span className="text-slate-500">(işaretlenmezse hesaplar "Tüm Kullanıcılar"da cari atanmamış olarak kalır; oradan taşıyabilir ya da silebilirsiniz)</span>}</label>}
            </div>
          )}
          step2Message={`${cari.name} silinsin mi?${n > 0 && withUsers ? ` ${n} kullanıcı hesabı da kalıcı olarak silinecek.` : ""} Bu işlem geri alınamaz.`} />
      )}
    </>
  );
}
